import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx } from "vue"

import CheckBoxStandard from '@/design-system/atoms/CheckBoxStandard.vue'
import ModalBase from './ModalBase.vue'
import { useI18n } from 'vue-i18n'
import { usePrivileges } from './privileges'
import { allActions } from './actionStore'


export default /*@__PURE__*/_defineComponent({
  __name: 'SettingsModal',
  setup(__props) {

const { t } = useI18n()

const privileges = usePrivileges()

const handleCheck = (action: string, value: Event) => {
  const checked = (value.target as HTMLInputElement).checked
  if (checked) {
    privileges.setAllowedActions(
      [...privileges.allowedActions.filter((a) => a !== action), action].filter(Boolean)
    )
  } else {
    const newActions = privileges.allowedActions.filter((a) => a !== action)
    privileges.setAllowedActions(newActions)
  }
}

const setAdmin = (value: Event) => {
  const checked = (value.target as HTMLInputElement).checked
  if (checked) {
    privileges.setAdmin()
  } else {
    privileges.unsetAdmin()
  }
}

const handleCheckHidden = (value: Event) => {
  const checked = (value.target as HTMLInputElement).checked
  if (checked) {
    privileges.showHidden()
  } else {
    privileges.hideHidden()
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalBase, {
    title: _unref(t)('general__text__settings') + ' (Admin)'
  }, {
    content: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(allActions), (action) => {
        return (_openBlock(), _createBlock(CheckBoxStandard, {
          key: action.actionName,
          checked: _unref(privileges).allowedActions.includes(action.actionName),
          title: `Action ${action.actionName}`,
          onValueChanged: (value) => handleCheck(action.actionName, value)
        }, null, 8, ["checked", "title", "onValueChanged"]))
      }), 128)),
      _createVNode(CheckBoxStandard, {
        checked: _unref(privileges).allowHidden,
        title: "Show Hidden",
        onValueChanged: _cache[0] || (_cache[0] = (value) => handleCheckHidden(value))
      }, null, 8, ["checked"]),
      _createVNode(CheckBoxStandard, {
        checked: _unref(privileges).isAdmin,
        title: "Is Admin",
        onValueChanged: _cache[1] || (_cache[1] = (value) => setAdmin(value))
      }, null, 8, ["checked"])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})